import reduceReducers from 'reduce-reducers';

import createParticipantReducer from 'app/modules/participants/actions/createParticipant';
import initialState from 'app/modules/participants/initialState';

export default reduceReducers(createParticipantReducer);

/*
 * participant list selectors
 */

export const getParticipants = state => {
  return state.allIds.map(id => getParticipantById(state, id));
};

/*
 * single participant selectors
 */

export const getParticipantById = (state, id) => {
  const participant = state.byId[id];
  if (!participant) {
    return null;
  }

  return participant;
};

export { initialState };
